import type { ServiceConnectionType } from '@/api/model'
import { sageHrServiceConnection } from './sageHr'
import type { ServiceConnectionTypeDefinition } from './types'

/**
 * Every connection type the portal can show. Order defines the create menu.
 * A new external service = one appended definition (plus its fields in
 * `ServiceConnectionFormValues`).
 */
export const serviceConnectionTypes: ServiceConnectionTypeDefinition[] = [sageHrServiceConnection]

export function getServiceConnectionDefinition(
  type: ServiceConnectionType | null | undefined,
): ServiceConnectionTypeDefinition | undefined {
  return serviceConnectionTypes.find((definition) => definition.type === type)
}

export * from './types'
